import {React, useContext,useState, useEffect} from 'react';
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";

import "react-toastify/dist/ReactToastify.css";

import Context from "context/context";
import reportAPI from 'apis/panel/reports/reports';
import { Box, FormControl, MenuItem, Select } from '../../../../../node_modules/@mui/material/index';

const EmployeeManagerInformation = ({ setDisableDropdown }) => {
    const { dispatch } = useContext(Context);
    const [employmentStatus,setEmploymentStatus] = useState('Active')
    
    const { getEmployeeManagerInfoReportAPI } = reportAPI();


      const handleExport = async () => {
        dispatch({ type: "SET_LOADING", payload: true });
        setDisableDropdown(true);
        await getEmployeeManagerInfoReportAPI(employmentStatus);
        setDisableDropdown(false);
        dispatch({ type: "SET_LOADING", payload: false });
      };

       const statusLabels = {
  Active: "Active",
  Inactive: "In Active",
};
    
  return (
    <div>
         
      <Grid container spacing={4} sx={{ mt: 2 }}>
           <Grid item xs={6} sm={6} md={3} lg={4}>
                  <Box className="labelproj">Employment Status
                    <span style={{ color: "red" }}>*</span>
                  </Box>
                  <FormControl fullWidth>
                    <Select
                      labelId="vra-label-2"
                      id="vra-select-2"
                      name="vra-select-2"
                      // multiple
                      displayEmpty
                      value={employmentStatus}
                      onChange={(e) => {
                        setEmploymentStatus(e.target.value);
                      }}
                      inputProps={{ "aria-label": "Timesheet Status" }}
                       renderValue={(selected) => {
        if (!selected) {
          return <em>Select Status</em>;
        }
       return statusLabels[selected];
      }}
                    >
                      
                      <MenuItem value={'Active'}>Active</MenuItem>
                      <MenuItem value={'Inactive'}>In Active</MenuItem>
                    
                    </Select>
                  </FormControl>
                </Grid>
                
        <Grid item xs={12} style={{ textAlign: "right", padding: "20px 0px" }}>

        
          <Button
            className="download-btn"
            startIcon={
              <DownloadForOfflineIcon
                style={{ fontSize: 30, verticalAlign: "middle" }}
              />
            }
            onClick={handleExport}
          >
            Export
          </Button>
        </Grid>
      </Grid>

    
    </div>
  )
}

export default EmployeeManagerInformation